export default "__VITE_ASSET__DIIljZOL__"